import script from "./LichessFriendView.vue?vue&type=script&setup=true&lang=js"
export * from "./LichessFriendView.vue?vue&type=script&setup=true&lang=js"

import "./LichessFriendView.vue?vue&type=style&index=0&id=b76a00d8&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b76a00d8"]])

export default __exports__